import { createBrowserHistory } from 'history';

export function getHistory({ routerBaseName }) {
    return createBrowserHistory({
        basename: routerBaseName,
    });
}
